"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DomainSearchResultComponent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _uxcore = require("@ux/uxcore2");
var _storeProvider = require("./../util/storeProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const _instancePath = 'freedomain_attachment.free_domain'; // constant value

class DomainSearchResultComponent extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      failed: false
    };
    this.handleAction = this.handleAction.bind(this);
  }
  handleAction() {
    const domainName = this.props.domainProductInfo.name;
    this.context.store.domainSearchApi.verify({
      query: domainName,
      apiKey: this.props.groupContent.apiKey
    }, isFreeAndAvailable => {
      if (isFreeAndAvailable) {
        this.context.store.updateInstance(_instancePath, {
          options: 'domain_name',
          domainName: domainName
        }).then(() => {
          return this.context.store.handleContinueClick();
        }).catch(() => {
          this.setState({
            failed: true
          });
        });
      } else {
        this.setState({
          failed: true
        });
      }
    });
  }
  render() {
    const {
      resultType,
      domainProductInfo = {},
      groupContent = {},
      disabled
    } = this.props;
    const {
      selectContinueButton = ''
    } = groupContent;
    const {
      name: domainName,
      salePrice,
      listPrice,
      showIcannFee
    } = domainProductInfo;
    const {
      store
    } = this.context;
    if (this.state.failed) {
      return /*#__PURE__*/React.createElement("div", {
        className: `p-sm p-3 mb-2 card ux-card card-block flex-row flex-sm-wrap align-items-center`
      }, /*#__PURE__*/React.createElement("div", {
        className: " h5 mb-0 flex-grow-1 text-muted break-word"
      }, groupContent.domainUnavailableForOfferTitle.replace('{fqdn}', domainName)));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: `p-sm p-3 mb-2 card ux-card card-block flex-row flex-sm-wrap align-items-center`
    }, /*#__PURE__*/React.createElement("div", {
      className: " h5 mb-0 flex-grow-1 text-muted break-word pr-2"
    }, domainName), /*#__PURE__*/React.createElement("div", {
      className: "flex-grow-1 flex-sm-grow-0 h4 mb-0"
    }, /*#__PURE__*/React.createElement("span", {
      className: "mr-4 d-inline-block"
    }, /*#__PURE__*/React.createElement("strike", null, listPrice)), /*#__PURE__*/React.createElement("span", {
      className: "text-primary mr-4 d-inline-block"
    }, salePrice, showIcannFee ? '*' : '')), /*#__PURE__*/React.createElement("div", {
      className: "flex-grow-1 flex-sm-grow-0"
    }, /*#__PURE__*/React.createElement(_uxcore.Button, {
      className: "btn-block",
      design: "primary",
      "data-eid": store.getEid(`select_domain_${resultType}_result`, 'submit', 'click'),
      onClick: this.handleAction,
      disabled: disabled,
      text: store.parseHtml(selectContinueButton)
    })));
  }
}
exports.DomainSearchResultComponent = DomainSearchResultComponent;
DomainSearchResultComponent.propTypes = {
  resultType: _propTypes.default.string,
  groupContent: _propTypes.default.object.isRequired,
  domainProductInfo: _propTypes.default.shape({
    name: _propTypes.default.string,
    salePrice: _propTypes.default.string,
    listPrice: _propTypes.default.string,
    hasIcannFee: _propTypes.default.bool
  }),
  disabled: _propTypes.default.bool
};
var _default = exports.default = (0, _storeProvider.provideContext)(DomainSearchResultComponent);